import { createFileRoute, redirect } from "@tanstack/react-router";

/* Menus opens on the calendar; the Kitchen agent is beside it, in the right-hand pane. */
export const Route = createFileRoute("/_authenticated/menus/")({
  beforeLoad: () => {
    throw redirect({ to: "/menus/calendar", replace: true });
  },
});
